import React from 'react'
import { Checkbox } from 'antd'
import { isLocked } from '../../config/constants'
import { getAge, getPf, getRankAndPosition } from '../../config/helperFunctions'
import { MdLock } from 'react-icons/md'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { openModal } from '../../redux/actions/interfaceModalActions'

const NewRosterCard = (props) => {
  const {
    data,
    index,
    state,
    handleClick,
    isPractice = false,
    checkbox,
    isReserve,
    isTeam,
    isOwnRoster,
  } = props

  const _id = data?.player_id?._id
  const PlayerID = data?.player_id?.PlayerID
  const Name = data?.player_id?.Name
  const pointsPerGame = data?.player_id?.pointsPerGame
  const Team = data?.player_id?.Team
  const Position = data?.player_id?.Position
  const PlayerCap = data?.player_id?.PlayerCap
  const BirthDate = data?.player_id?.BirthDate
  const gamesPlayed = data?.player_id?.gamesPlayed
  const Opponent = data?.player_id?.Opponent
  const InjuryStatus = data?.player_id?.InjuryStatus

  const { id } = useParams()
  const dispatch = useDispatch()

  const getColor = (value) => {
    const obj = {
      LW: '#FF72FF',
      C: '#FFFF72',
      D: '#EE909F',
      G: '#93FF93',
      RW: '#98CCE6',
    }
    return obj[value]
  }

  return (
    <div className='nrc_container'>
      <div className='serial_number'>
        <p>{index + 1}</p>
      </div>
      <div className='content_box'>
        <div className='content_box_left'>
          <span style={{ color: getColor(Position) }}>{Position}</span>
        </div>
        <div className='content_box_center'>
          <div className='top'>
            <h2
              onClick={() => {
                dispatch(
                  openModal({
                    playerID: PlayerID,
                    isReserve: isReserve ? true : false,
                    teamId: id ? id : null,
                    teamName: isTeam?.teamName ? isTeam?.teamName : '',
                    teamLogo: isTeam?.teamLogo ? isTeam?.teamLogo : null,
                    isOwnRoster,
                  }),
                )
              }}
            >
              {Name}
            </h2>

            <p style={{ marginLeft: '-10px' }}>-{Team}</p>
            {data?.inWaiver && <span className='waiver_circle'>W</span>}
            {data?.isPlayerLocked && (
              <MdLock size={18} color={'#fff'} style={{ marginBottom: '-3px' }} />
            )}
            {InjuryStatus === 'Out' ? (
              <>
                <span className='injury_plus'>
                  <b>+</b>
                </span>
                <p className='injury_plus_text'>O</p>
              </>
            ) : InjuryStatus === 'Questionable' ? (
              <p className='injury_status'>Q</p>
            ) : InjuryStatus === 'Doubtful' ? (
              <p className='injury_status'>D</p>
            ) : InjuryStatus === 'Suspended' ? (
              <p className='injury_status'>SSPD</p>
            ) : InjuryStatus === 'Injured Reserve' ? (
              <p className='injury_status'>IR</p>
            ) : (
              ''
            )}
            <p>AGE:{getAge(BirthDate) || '-'}</p>
            <p>GP:{gamesPlayed || '-'}</p>
          </div>
          <div className='bottom'>
            <p>
              AVG.PF:
              {data?.player_id?.dailyScoring ? getPf(data?.player_id?.dailyScoring)?.apf : '-'}
            </p>
            <p>PPG:{pointsPerGame || '-'}</p>
            <p>P-RANK:{getRankAndPosition(data?.player_id?.dailyScoring)?.playerOverallRank}</p>
            <p>OPP:{Opponent || '-'}</p>
            <p>CAPHIT:{PlayerCap ? `$${PlayerCap?.toLocaleString()}` : '-'}</p>
          </div>
        </div>
        <div className='content_box_right'>
          {checkbox && (
            <>
              {isPractice ? (
                <Checkbox
                  onChange={(event) => handleClick(event.target.checked, _id)}
                  checked={state?.includes(_id)}
                  disabled={isLocked() || data?.isPlayerLocked}
                >
                  Protected
                </Checkbox>
              ) : (
                <Checkbox
                  onChange={(event) => handleClick(event.target.checked, _id)}
                  checked={state?.includes(_id)}
                  disabled={isLocked() || data?.isPlayerLocked}
                >
                  Non-Active
                </Checkbox>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default NewRosterCard
